import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

/**
 * FluentGrid is a convienience wrapper to make use of Fluent UI Grid Styles.
 */
const FluentGrid = ({ row, col, sm, md, lg, dir, children, className }) => {
  const isContainer = !col && !row;
  const dirProp = isContainer ? { dir } : {};

  return (
    <div
      className={clsx(className, {
        'ms-Grid': isContainer,
        'ms-Grid-col': col,
        'ms-Grid-row': row,
        [`ms-sm${sm}`]: sm,
        [`ms-md${md}`]: md,
        [`ms-lg${lg}`]: lg,
      })}
      {...dirProp}
    >
      {children}
    </div>
  );
};

FluentGrid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  row: PropTypes.bool,
  col: PropTypes.bool,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  dir: PropTypes.string,
};

FluentGrid.defaultProps = {
  className: '',
  row: false,
  col: false,
  sm: null,
  md: null,
  lg: null,
  dir: 'ltr',
};

export default FluentGrid;
